export default "__VITE_ASSET__DUufay9V__"